import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Footer = () => {
  const footerLinks = {
    'Products': [
      { name: 'Keyboards', path: '/shop?category=keyboards' },
      { name: 'Joycon', path: '/shop?category=joycon' },
      { name: 'Lava Lamp', path: '/shop?category=lava-lamp' },
      { name: 'Nintendo Accessories', path: '/shop?category=nintendo-accessories' }
    ],
    'Support': [
      { name: 'Customer Service', path: '/support' },
      { name: 'Warranty Policy', path: '/warranty' },
      { name: 'Returns Policy', path: '/returns' },
      { name: 'FAQ', path: '/faq' }
    ],
    'Company': [
      { name: 'About Us', path: '/about' }
    ],
    'Legal': [
      { name: 'Terms of Use', path: '/terms' },
      { name: 'Privacy Policy', path: '/privacy' },
      { name: 'Cookie Policy', path: '/cookies' },
      { name: 'Legal Notice', path: '/legal' }
    ]
  };


  return (
    <footer className="bg-dark-500 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center mb-4">
              {/* CHILL GAMING - Simple White Text */}
              <span
                className="font-bold text-xl text-white"
                style={{
                  fontFamily: 'Orbitron, monospace',
                  letterSpacing: '1px'
                }}
              >
                CHILL GAMING
              </span>
            </Link>
            <p className="text-gray-400 mb-6 max-w-sm">
              Professional gaming accessories manufacturer using RGB-enhanced precision engineering technology to provide the ultimate gaming experience for players worldwide.
            </p>

          </div>

          {/* Footer Links */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category} className="space-y-3">
              <h4 className="text-white font-semibold">{category}</h4>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-gray-400 hover:text-primary-400 transition-colors duration-200"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Contact Info */}
        <div className="border-t border-white/10 mt-12 pt-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="space-y-2">
              <h4 className="text-white font-semibold flex items-center space-x-2">
                <span>📍</span>
                <span>Address</span>
              </h4>
              <p className="text-gray-400">
                Marina Bay Financial Centre, Singapore<br />
                123 Tech Avenue, 18th Floor
              </p>
            </div>
            <div className="space-y-2">
              <h4 className="text-white font-semibold flex items-center space-x-2">
                <span>📍</span>
                <span>Meet Up Free</span>
              </h4>
              <p className="text-gray-400">
                Available at Sengkang & Orchard locations
              </p>
            </div>
            <div className="space-y-2">
              <h4 className="text-white font-semibold flex items-center space-x-2">
                <span>📞</span>
                <span>Contact</span>
              </h4>
              <p className="text-gray-400">
                Phone: +60 11-1424 0380 (WhatsApp)<br />
                Customer Service<br />
                Email: chillgaming.sg@gmail.com
              </p>
            </div>
            <div className="space-y-2">
              <h4 className="text-white font-semibold flex items-center space-x-2">
                <span>🕒</span>
                <span>Business Hours</span>
              </h4>
              <p className="text-gray-400">
                Mon - Fri: 9:00 AM - 9:00 PM<br />
                Weekends: 10:00 AM - 10:00 PM
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-white/10 mt-8 pt-8 flex justify-center">
          <div className="text-gray-400 text-sm">
            © 2025 CHILL GAMING. All rights reserved.
          </div>
        </div>

        {/* AI Badge */}
        <motion.div 
          className="mt-8 flex justify-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-primary-500/20 to-accent-500/20 rounded-full border border-primary-500/30">
            <span className="w-2 h-2 bg-primary-500 rounded-full animate-pulse"></span>
            <span className="text-sm text-primary-400 font-medium">
              Powered by Advanced AI Technology
            </span>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;